module.exports = __webpack_public_path__ + "img/kz.4bea1b00.svg";